var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',{domProps:{"innerHTML":_vm._s(_vm.$t('message.copyright', [_vm.currentYear]))}})])}
var staticRenderFns = []

export { render, staticRenderFns }